angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/suppressed_emails/:id', {
        template: require('./suppressed_email.html'),
        controller: 'SuppressedEmailController'
    });
})
.controller('SuppressedEmailController', function($scope, $window, $routeParams, SuppressedEmail){
  $scope.email = SuppressedEmail.get({id: $routeParams.id});

  return $scope.delete = () => {
    SuppressedEmail.delete({id: $routeParams.id}, () => $window.history.back());
  };
});



// WEBPACK FOOTER //
// ./views/suppressed_email/suppressed_email_controller.js